export default function WhatsAppFloat() {
  const message = encodeURIComponent(
    'Olá Ednilson! Vi o site da Home Office Premium e gostaria de mais informações.'
  );

  return (
    <a
      href={`https://wa.me/5581982030285?text=${message}`}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-5 right-5 z-[9999] w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-white text-primary-600 hover:bg-primary-50 transition-all duration-300 cursor-pointer border border-background-200/60 hover:border-primary-200"
      aria-label="Falar com a Home Office Premium pelo WhatsApp"
    >
      <i className="ri-whatsapp-line text-xl md:text-2xl"></i>
    </a>
  );
}